import React from "react"
import UsersTable from "../../../Admin/components/UsersTable";

export default function AdminHome(){

    return (
        <div>
            <UsersTable/>
        </div>
    )

}